import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import InstantShopAd from '../components/InstantShopAd';

export default withRouter(
  connect(
    state => ({
      user: state.user,
      basket: state.basket,
    })
  )(InstantShopAd)
);
